document.addEventListener("DOMContentLoaded", () => {
  const getIsFR = () => {
    const htmlLang = (document.documentElement.lang || "").toLowerCase(); // fr, fr-fr, en...
    const shopifyLocale = (window.Shopify && Shopify.locale ? Shopify.locale.toLowerCase() : "");
    return htmlLang.startsWith("fr") || shopifyLocale.startsWith("fr");
  };

  const translate = () => {
    const isFR = getIsFR();

    // --- Bouton + popup : on remplace UNIQUEMENT dans la popup de l'app pour éviter de casser le site ---
    const modal = document.querySelector('[role="dialog"], .back-in-stock, .modal, .popup, [class*="back-in-stock"]');
    if (!modal) return;

    // Titre
    modal.querySelectorAll("h1,h2,h3,h4").forEach(h => {
      const t = h.textContent.trim().toLowerCase();
      if (t.includes("notify me")) {
        h.textContent = isFR ? "ME PRÉVENIR QUAND DISPONIBLE" : "NOTIFY ME WHEN AVAILABLE";
      }
    });

    // Texte + privacy
    modal.querySelectorAll("p,span,div").forEach(n => {
      const txt = n.textContent.trim();

      if (txt === "We'll notify you when this product is back in stock.") {
        n.textContent = isFR
          ? "Nous vous préviendrons dès que ce produit sera de nouveau disponible."
          : "We'll notify you when this product is back in stock.";
      }

      if (txt === "We don't share your information with others.") {
        n.textContent = isFR
          ? "Nous ne partageons jamais vos informations avec des tiers."
          : "We don't share your information with others.";
      }
    });

    // Placeholder
    const email = modal.querySelector('input[placeholder]');
    if (email) {
      const ph = email.getAttribute("placeholder") || "";
      if (ph.toLowerCase().includes("email")) {
        email.setAttribute("placeholder", isFR ? "Votre adresse e-mail" : "Email address");
      }
    }

    // Bouton dans la popup
    modal.querySelectorAll("button,input[type='submit'],input[type='button']").forEach(b => {
      const label = (b.textContent || b.value || "").trim().toLowerCase();
      if (label.includes("notify")) {
        if (b.tagName === "INPUT") b.value = isFR ? "Me prévenir quand disponible" : "Notify me when available";
        else b.textContent = isFR ? "Me prévenir quand disponible" : "Notify me when available";
      }
    });
  };

  // On lance plusieurs fois pendant 5s (le temps que l'app injecte la popup), puis stop → pas de lag
  let tries = 0;
  const timer = setInterval(() => {
    tries += 1;
    translate();
    if (tries >= 25) clearInterval(timer);
  }, 200);

  // Bonus: quand on clique sur un bouton "notify", on relance la traduction (la popup apparaît après)
  document.addEventListener("click", () => {
    tries = 0;
  }, true);
});
